
// styles
import Styles from "./holidayNoticeModal.module.css"

// redux
import { useSelector, useDispatch } from "react-redux"

// components
import WenbitModal from "../../../components/Modal/Modal"
import Button from "../../../components/Button/Button"

// icons
import * as BsIcons from "react-icons/bs"

// iconify
import { Icon } from '@iconify/react'

// helpers
import { nextDisclaimer } from "./redux/holidayNoticeModalSlice"

function HolidayNoticeModal({ open = false, handleClose }) {
  const dispatch = useDispatch()
  const modalState = useSelector((state) => state.holidayNoticeModalState)
  const { data: currentDisclaimer, disclaimers, currentIndex } = modalState

  console.log('HolidayNoticeModal render:', { open, modalState })

  const handleCloseModal = () => {
    dispatch(nextDisclaimer())
    if (handleClose) {
      handleClose()
    }
  }

  const renderIcon = () => {
    if (!currentDisclaimer?.icon) {
      return (
        <Icon
          icon="twemoji:christmas-tree"
          width="60"
          height="60"
          style={{ display: 'block' }}
        />
      )
    }

    const DynamicIcon = BsIcons[currentDisclaimer.icon]
    if (DynamicIcon) {
      return <DynamicIcon size={60} color="var(--primary-color)" />
    }

    return (
      <Icon
        icon={currentDisclaimer.icon}
        width="60"
        height="60"
        style={{ display: 'block' }}
      />
    )
  }

  return (
    <>
      <WenbitModal
        open={open}
        showCloseButton={true}
        onClose={handleCloseModal}
        showLineHeader={true}
        lineHeaderColor="var(--primary-color)"
        modalWidth={500}
        render={() => (
          <div className={Styles.bodyContainer}>
            <div className={Styles.iconContainer}>
              <div className={Styles.christmasIcon}>
                {renderIcon()}
              </div>
              {!currentDisclaimer?.icon && (
                <div className={Styles.snowflakes}>
                  <div className={Styles.snowflake}>❄️</div>
                  <div className={Styles.snowflake}>❄️</div>
                  <div className={Styles.snowflake}>❄️</div>
                </div>
              )}
            </div>

            <span className={Styles.title}>{currentDisclaimer?.title || 'Notice'}</span>

            <div className={Styles.messageContainer}>
              <div
                className={Styles.message}
                dangerouslySetInnerHTML={{ __html: currentDisclaimer?.content || currentDisclaimer?.message }}
              />
            </div>

            <div className={Styles.buttonsContainer}>
              <Button
                text={currentIndex < disclaimers.length - 1 ? "Next" : "I Understand"}
                style={{
                  width: "fit-content",
                  background: "var(--primary-color)",
                  border: "none"
                }}
                onClick={handleCloseModal}
              />
            </div>
          </div>
        )}
      />
    </>
  )
}

export default HolidayNoticeModal
